(function($) {
  $(window).scroll(function() {
    fixNavigationOnScroll();
  });

  $(document).ready(function() {
    fixNavigationOnScroll();
  });

  /**
   * Toogle navigation
   */
  $('button.navbar-toggle').click(function() {
    $('body').toggleClass('nav-open');
  });

  /**
   * Fix navigation
   */
  function fixNavigationOnScroll() {
    var scrollTop = $(window).scrollTop();
    var headerScrollOffset = parseInt(50);

    if (scrollTop > headerScrollOffset) {
      $('body').addClass('nav-fixed');
    } else {
      $('body').removeClass('nav-fixed');
    }
  }

  // Select all links with hashes
  $('a[href*="#"]:not(.nav-link)')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          //event.preventDefault();
          $('html, body').animate(
            {
              scrollTop: target.offset().top - 20,
            },
            1000,
          );

          if ($(window).width() < 1200) {
            $('body').toggleClass('nav-open');
          }
        }
      }
    });

  if ($('body').hasClass('home')) {
    if ($(window).width() > 992) {
      $(document).on('scroll', function(e) {
        $('section').each(function() {
          if (
            $(this).offset().top < window.pageYOffset + 70 &&
            $(this).offset().top + $(this).height() > window.pageYOffset + 70
          ) {
            var data = $(this).attr('id');
            $('li.menu-item').removeClass('current');
            $('li.menu-' + data).addClass('current');
            if (data != undefined) {
              window.location.hash = data;
            }
          }
        });
      });
    }
  }

  $(document).ready(function() {
    $('.block-full-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  });

  /**
   *  Page Hero Image Parallax
   */
  function handleImageParallax(image, offset) {
    var scrollPercent =
      (100 * $(window).scrollTop()) /
      ($(document).height() - $(window).height());

    var translateValue = (offset * scrollPercent) / 100;

    image.css('transform', 'translate(-50%, ' + translateValue + 'px)');
  }

  if ($('.page-hero__image-wrapper').length) {
    $(window).scroll(function(event) {
      $('.page-hero__image-wrapper').each(function() {
        handleImageParallax($(this).find('img'), 125);
      });
    });
  }

  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function() {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function(marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function() {
    $('.acf-map').each(function() {
      var map = initMap($(this));
    });
  });
})(jQuery);

function openModal(id) {
  var element = document.getElementById('overlay-' + id);
  element.classList.add('open');
}

function closeModal(id) {
  var element = document.getElementById('overlay-' + id);
  element.classList.remove('open');
}
